import * as Sentry from '@sentry/browser';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import 'dayjs/locale/ru';

import { IS_PRODUCTION_ENVIROMENT, SENTRY_DSN } from '~/src/constants';

const bootstrap = () => {
    dayjs.locale('ru');
    dayjs.extend(customParseFormat);

    Sentry.init({
        enabled: IS_PRODUCTION_ENVIROMENT,
        dsn: SENTRY_DSN,
        tracesSampleRate: 0.5,
        ignoreErrors: [
            'find variable: ym',
            'ym is not defined',
            'find variable: VK',
            'Vk is not defined',
            'fbq is not defined',
        ],
    });
};

export default bootstrap;
